import ProductsConsume from './ProductsConsume';

export default ProductsConsume;